import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { ZeitQuerySorterConfig } from 'fa-kt.types';
import { ZeitService } from '../service';

@Component({
  selector: 'fa-kt-zeit-sorter',
  templateUrl: './zeit-sorter.component.html',
  styleUrls: ['./zeit-sorter.component.css'],
})
export class ZeitSorterComponent {
  public ZeitSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public zeit: ZeitService,
  ) {
    this.ZeitSorterConfig = ZeitQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
